window.showTab = (id) => {
  const tabs = document.querySelector('.product-tabs');

  tabs.querySelector('.product-tabs__nav-item_active').classList.remove('product-tabs__nav-item_active');
  tabs.querySelector('.product-tab_active').classList.remove('product-tab_active');

  tabs.querySelector(`.product-tabs__nav-item_${id}`).classList.add('product-tabs__nav-item_active');
  tabs.querySelector(`#${id}`).classList.add('product-tab_active');

  tabs.scrollIntoView({behavior: 'smooth', block: 'start'})
};
